import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export default function ContractorMatchesLoading() {
  return (
    <div className="min-h-screen bg-background pb-20">
      <div className="mx-auto max-w-screen-sm px-4 py-4 space-y-4">
        {/* Job selector pills skeleton */}
        <div className="flex gap-2 overflow-hidden">
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} className="h-12 w-32 shrink-0 rounded-full" />
          ))}
        </div>

        {/* Job summary skeleton */}
        <Skeleton className="h-12 w-full rounded-xl" />

        {/* Hint text */}
        <Skeleton className="h-4 w-64 mx-auto" />

        {/* Worker match cards skeleton */}
        {[...Array(3)].map((_, i) => (
          <Card key={i}>
            <CardContent className="p-5 space-y-3">
              <div className="flex items-start gap-3">
                <Skeleton className="h-14 w-14 rounded-full shrink-0" />
                <div className="flex-1 space-y-2">
                  <Skeleton className="h-5 w-32" />
                  <Skeleton className="h-4 w-full" />
                  <div className="flex gap-3">
                    <Skeleton className="h-4 w-16" />
                    <Skeleton className="h-4 w-20" />
                    <Skeleton className="h-4 w-20" />
                  </div>
                </div>
              </div>
              <Skeleton className="h-14 w-full" />
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
